/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { IconArrowRight } from 'components/Icons';
import { v4 as uuidv4 } from 'uuid';
import { cx } from '@linaria/core';
import { flex } from 'styles/utils';
// import { StarComponent } from 'components/List/components/Star/Star';
// import { SupportedListingEntities } from 'modules/Listings/types';
import { useDataCollection } from 'modules/AnalyticsCollection/AnalyticsCollectionProvider';
import { useFeatureFlagsLD } from 'modules/FeatureFlagsLD/FeatureFlagsProviderLD';
import { Spinner } from 'components/Spinner';
import { HomeCard } from '../components/HomeCard';
import { Card } from './Card';
import { HorizontalLayout } from '../layout/HorizontalLayout';
import { starBadge } from '../Badge/badge.styles';
import { useSetupComputeAndDeployModal } from '../components/SetupComputeAndDeployModal';
import { useTrendingModels } from '../hooks/useTrendingModels';
import { HomeCardId, mapIdToTitle } from '../constants';

export function TrendingModels() {
  const { trendingModels, isLoading } = useTrendingModels();

  const { track } = useDataCollection();
  const openSetupComputeAndDeployModal = useSetupComputeAndDeployModal();
  const { homePageDeployTrendingModelLDFF } = useFeatureFlagsLD();

  const trendingModelsToShow = trendingModels.slice(0, 9);

  return (
    <HomeCard title={mapIdToTitle[HomeCardId.TrendingModels]} description="Deploy these models with a single click or try in Playground.">
      <HorizontalLayout>
        <>
          {isLoading ? (
            <Spinner />
          ) : (
            trendingModelsToShow.map((data) => {
              const Icon = data.icon;

              return (
                <Card
                  key={uuidv4()}
                  icon={<Icon />}
                  title={data.title}
                  body={data.body}
                  // badge={<StarComponent entity={{} as SupportedListingEntities} data-testid="app-star-btn" />}
                  badgeClassName={starBadge}
                  footer={
                    <div
                      className={cx(flex.init, flex.gap.half, flex.justifyContent.between, flex.alignItems.center)}
                      style={{
                        width: '100%',
                      }}
                    >
                      <a
                        className={cx(flex.init, flex.gap.half, flex.justifyContent.center, flex.alignItems.center, 'link')}
                        href={`/playground?model=${data.modelId}__${data.modelVersionId}&user_id=${data.userId}&app_id=${data.appId}`}
                        onClick={() => track('Home Page -> Test in Playground', { modelId: data.modelId, modelUserId: data.userId })}
                      >
                        TEST IN PLAYGROUND
                        <IconArrowRight size={16} />
                      </a>
                      {homePageDeployTrendingModelLDFF && (
                        <a
                          role="button"
                          tabIndex={0}
                          className={cx(flex.init, flex.gap.half, flex.justifyContent.center, flex.alignItems.center, 'link')}
                          onClick={() => {
                            track('Home Page -> Deploy Model', { modelId: data.modelId, modelUserId: data.userId });
                            openSetupComputeAndDeployModal({ model: data });
                          }}
                          onKeyDown={(evt) => {
                            if (evt.key === 'Enter' || evt.key === ' ') {
                              evt.preventDefault(); // a11y: prevents scrolling when spacebar is pressed
                              evt.currentTarget.click();
                            }
                          }}
                        >
                          DEPLOY THE MODEL
                          <IconArrowRight size={16} />
                        </a>
                      )}
                    </div>
                  }
                />
              );
            })
          )}
          {/* <BasicCard
                icon={<IconGlobe size={24} color={baseTheme.light.colors.primary600} />}
                title={
                  <Link href="/explore/models" className={cx(flex.init, flex.gap.half, flex.justifyContent.center, flex.alignItems.center, 'link')}>
                    EXPLORE ALL RESOURCES
                  </Link>
                }
              /> */}
        </>
      </HorizontalLayout>
    </HomeCard>
  );
}
